const KEY = 'startedFromStack';

export const setStartedFromStack = () => {
  try {
    sessionStorage.setItem(KEY, 'true');
  } catch {
    // Ignore if storage is unavailable.
  }
};

export const getStartedFromStack = (): boolean => {
  try {
    return sessionStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
};

export const clearStartedFromStack = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Ignore if storage is unavailable.
  }
};
